import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
// import { SearchProvider } from "./frontend/Common/Pages/Search/SearchContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <SearchProvider>
  <HelmetProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </HelmetProvider>
  // </SearchProvider>
);
